import { RouteConfig } from 'vue-router';
import { Dictionary } from 'vuex';

import { ConfigGroup } from '@/interfaces/configGroup';
import { ConfigItem } from '@/interfaces/configItem';
import { configRoute } from '@/router/mainRoute/config.route';
import { flat } from './flat';

/**
 * Generuje elementy widoku konfiguracji
 *
 * @export
 * @returns {ConfigGroup[]}
 */
export function generateConfig(): ConfigGroup[] {
  if (configRoute.children && configRoute.children.length) {
    return generateConfigFromChildren(configRoute.children);
  }
  return [];
}

/**
 * Generuje elementy widoku konfiguracji
 *
 * @param {RouteConfig[]} children
 * @returns {ConfigGroup[]}
 */
function generateConfigFromChildren(children: RouteConfig[]): ConfigGroup[] {
  const menuRoutes = children.filter(child => child.meta && child.meta.config);
  const groupedMenuRoutes: Dictionary<ConfigGroup> = menuRoutes.reduce(
    (groups: any, route) => addChild(route, groups),
    {}
  );
  return Object.values(groupedMenuRoutes).map(setGroupPermissions);
}

/**
 * Dodaje dziecko do grup
 *
 * @param {RouteConfig} route
 * @param {Dictionary<ConfigGroup>} groups
 * @returns {Dictionary<ConfigGroup>}
 */
function addChild(route: RouteConfig, groups: Dictionary<ConfigGroup>): Dictionary<ConfigGroup> {
  const metadata = route.meta.config;
  if (!metadata.group) {
    metadata.group = 'Ogólne';
  }
  if (!groups[metadata.group]) {
    groups[metadata.group] = { title: metadata.group, children: [] };
  }
  groups[metadata.group].children.push(routeConfigToConfigItem(route));
  return groups;
}

/**
 * Ustawia uprawnienia grupy
 *
 * @param {ConfigGroup} group
 * @returns {ConfigGroup}
 */
function setGroupPermissions(group: ConfigGroup): ConfigGroup {
  group.permissions = flat(group.children.map((child: any) => child.permissions));
  return group;
}

/**
 * Mapuje konfigurację route na element wiodku konfiguracji
 *
 * @param {RouteConfig} route
 * @returns {ConfigItem}
 */
function routeConfigToConfigItem(route: RouteConfig): ConfigItem {
  const metadata = route.meta.config;
  return {
    title: metadata.title,
    name: metadata.name || route.name,
    permissions: metadata.permissions,
    icon: metadata.icon
  };
}
